(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("@emotion/react"), require("codemirror"), require("decap-cms-ui-default"));
	else if(typeof define === 'function' && define.amd)
		define("DecapCmsWidgetCode", ["react", "@emotion/react", "codemirror", "decap-cms-ui-default"], factory);
	else if(typeof exports === 'object')
		exports["DecapCmsWidgetCode"] = factory(require("react"), require("@emotion/react"), require("codemirror"), require("decap-cms-ui-default"));
	else
		root["DecapCmsWidgetCode"] = factory(root["React"], root["DecapCmsDefaultExports"]["EmotionCore"], root["CodeMirror"], root["DecapCmsUiDefault"]);
})(window, (__WEBPACK_EXTERNAL_MODULE__2244__, __WEBPACK_EXTERNAL_MODULE__1756__, __WEBPACK_EXTERNAL_MODULE__5159__, __WEBPACK_EXTERNAL_MODULE__3327__) => {
return 